module.exports = __webpack_public_path__ + "static/media/top-it.b835968d.png";